import Loadable from 'my-components/Loadable';

export { default as LinkedOnlineCourseSections } from './LinkedOnlineCourseSections';
export { default as LoadingFallback } from './LoadingFallback';
export { default as SolutionContent } from './SolutionContent';

export default Loadable(() => import(/* webpackChunkName: "quiz-question" */ './QuizQuestion'), { hideLoader: true });
